import { combineReducers } from 'redux';

import searchParams, { IState as ISearchParamsState } from './searchParams';
import searchResults, { IState as ISearchResultsState } from './searchResults';
import activeAsset, { IState as IActiveAssetState } from './activeAsset';
import notificationSettings, { IState as INotificationSettingsState } from './notificationSettings';
import exporttemplatesettings, { IState as IExportTemplateSettingsState } from './exporttemplateSettings';
import contentPreferences, { IState as IContentPreferencesState } from './contentPreferences';
import exchangeInfo, { IState as IExchangeInfoState } from './exchangeInfo';
import downloadPriority, { IState as IDownloadPriorityState } from './downloadPriority';
import vendorConsentSettings, { IState as IVendorConsentSettingsState } from './vendorConsentSettings';
import vendorData, { IState as IVendorDataState } from './vendorData';
import gameScheduleForm, { IState as IGameScheduleFormState } from './gameScheduleForm';
import updateAssetGameScheduleDialog, { IState as IUpdateAssetGameScheduleDialogState } from './updateAssetGameScheduleDialog';
import updateGameScheduleDialog, { IState as IUpdateGameScheduleDialogState } from './updateGameScheduleDialog';
import createGameScheduleDialog, { IState as ICreateGameScheduleDialogState } from './createGameScheduleDialog';
import uploadDialog, { IState as IUploadDialogState } from './uploadDialog';
import contactInfoDialog, { IState as IContactInfoDialogState } from './contactInfoDialog';
import initExchange, { IState as IInitExchangeState } from './initExchange';
import activeUsers, { IState as IActiveUsersState } from './activeUsers';

export enum SettingsMenuItems {
  VendorData = 'Authorized Teams',
  ContentPreferences = 'Content Preferences',
  ExchangeInfo = 'Exchange Info',
  ExportTemplate = 'Export File Name',
  TimeoutTeams = 'Non Compliant Teams',
  ComplianceBoardOdk = 'ODK Compliance',
  SubPreferences = 'Subscription Settings',
  ComplianceBoardTv = 'TV Compliance',
  VendorAccess = 'Vendor Consent'
}

export interface IState {
  searchParams: ISearchParamsState;
  searchResults: ISearchResultsState;
  activeAsset: IActiveAssetState;
  notificationSettings: INotificationSettingsState;
  exporttemplatesettings: IExportTemplateSettingsState;
  contentPreferences: IContentPreferencesState;
  exchangeInfo: IExchangeInfoState;
  downloadPriority: IDownloadPriorityState;
  vendorConsentSettings: IVendorConsentSettingsState;
  vendorData: IVendorDataState;
  gameScheduleForm: IGameScheduleFormState;
  updateAssetGameScheduleDialog: IUpdateAssetGameScheduleDialogState;
  updateGameScheduleDialog: IUpdateGameScheduleDialogState;
  createGameScheduleDialog: ICreateGameScheduleDialogState;
  uploadDialog: IUploadDialogState;
  contactInfoDialog: IContactInfoDialogState;
  initExchange: IInitExchangeState;
  activeUsers: IActiveUsersState;
}

const reducers = combineReducers({
  searchParams,
  searchResults,
  activeAsset,
  notificationSettings,
  exporttemplatesettings,
  contentPreferences,
  exchangeInfo,
  downloadPriority,
  vendorConsentSettings,
  vendorData,
  gameScheduleForm,
  updateAssetGameScheduleDialog,
  updateGameScheduleDialog,
  createGameScheduleDialog,
  uploadDialog,
  contactInfoDialog,
  initExchange,
  activeUsers,
});

export default reducers;
